import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router-dom";

const baseStyle = css`
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 10px 0;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  border-radius: 12px;
  padding: 15px;

  color: ${({ theme, role }) => theme.buttons[role].text};
  background: ${({ theme, role }) => theme.buttons[role].background};
  border: 1px solid ${({ theme, role }) => theme.buttons[role].border};

  :hover {
    color: ${({ theme, role }) => theme.buttons[`${role}_inverse`].text};
    background: ${({ theme, role }) =>
      theme.buttons[`${role}_inverse`].background};
    border: 1px solid
      ${({ theme, role }) => theme.buttons[`${role}_inverse`].border};
  }
  :disabled {
    color: ${({ theme, role }) => theme.buttons[`${role}_disabled`].text};
    background: ${({ theme, role }) =>
      theme.buttons[`${role}_disabled`].background};
    border: 1px solid
      ${({ theme, role }) => theme.buttons[`${role}_disabled`].border};
  }

  text-decoration: none;
  display: ${(state) => state.display};
  width: ${(state) => (state.display === "block" ? "100%" : "initial")};
  cursor: ${(state) => (state.disabled ? "" : "pointer")};
`;

export const Btn = styled.button`
  ${baseStyle}
`;
export const Link = styled(RouterLink)`
  ${baseStyle}
`;
export const A = styled.a`
  ${baseStyle}
`;
